import { render } from "./Standing.vue?vue&type=template&id=34bbd28f&scoped=true"
import script from "./Standing.vue?vue&type=script&lang=js"
export * from "./Standing.vue?vue&type=script&lang=js"

import "./Standing.vue?vue&type=style&index=0&id=34bbd28f&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bbd28f"]])

export default __exports__